export enum Steps {
  YourFlightQuote = 'Your flight quote',
  TravelerDetails = 'Traveler details',
  ProtectionPlans = 'Protection plans',
  BookingOptions = 'Booking options',
  OverviewAndPayment = 'Overview & confirm',
}

export const resolveCheckoutSteps = ({
  ancillaryUpsell,
  tierChangeMode,
  isChangeMode,
  tiers,
  perpetual,
}: {
  ancillaryUpsell?: boolean;
  tierChangeMode?: boolean;
  isChangeMode?: boolean;
  tiers?: boolean;
  perpetual?: boolean;
}) => {
  if (perpetual) {
    return [Steps.OverviewAndPayment];
  }

  if (ancillaryUpsell) {
    return [Steps.ProtectionPlans, Steps.OverviewAndPayment];
  }

  if (tierChangeMode) {
    return [Steps.YourFlightQuote, Steps.BookingOptions, Steps.OverviewAndPayment];
  }

  if (isChangeMode) {
    return [Steps.YourFlightQuote, Steps.ProtectionPlans, Steps.OverviewAndPayment];
  }

  if (tiers) {
    return [
      Steps.YourFlightQuote,
      Steps.BookingOptions,
      Steps.TravelerDetails,
      Steps.OverviewAndPayment,
    ];
  }

  return [
    Steps.YourFlightQuote,
    Steps.ProtectionPlans,
    Steps.TravelerDetails,
    Steps.OverviewAndPayment,
  ];
};
